/**
 * Web's worker factory for `@reflecto/client-core`'s `createReceiverWorkerClient`
 * (TASK-27 M4 — the worker client is platform-clean and shared verbatim with
 * the extension; only the ONE line that resolves the worker script's URL is
 * platform-specific). Vite's `new URL("...", import.meta.url)` pattern
 * statically analyzes this call and bundles `opfsReceiverWorker.ts` as its
 * own worker chunk — no separate `vite.config.ts` entry needed (unlike the
 * extension, which must reference a fixed `chrome-extension://` dist path
 * via `browser.runtime.getURL` instead).
 */

export function createWebOpfsWorker(): Worker {
  return new Worker(
    new URL(
      "../../../../packages/client-core/src/filetransfer/opfsReceiverWorker.ts",
      import.meta.url
    ),
    { type: "module" }
  );
}
